import { GetCoupons } from "../../Services/MainServices";

export const FETCH_COUPONS_REQUEST = "FETCH_COUPONS_REQUEST";
export const FETCH_COUPONS_SUCCESS = "FETCH_COUPONS_SUCCESS";
export const FETCH_COUPONS_FAILURE = "FETCH_COUPONS_FAILURE";

export const fetchCoupons = () => async (dispatch, getState) => {
    dispatch({ type: FETCH_COUPONS_REQUEST });
    try {
        // Get user_id from Redux state
        const user_id = getState().auth?.user?.user_id;
        const response = await GetCoupons();
        if (response.status === 200 && response.data) {
            dispatch({ type: FETCH_COUPONS_SUCCESS, payload: response.data.data });
        } else {
            dispatch({
                type: FETCH_COUPONS_FAILURE,
                error: response.data?.message || "Failed to fetch coupons",
            });
        }
    } catch (error) {
        dispatch({
            type: FETCH_COUPONS_FAILURE,
            error: error.message || "Failed to fetch coupons",
        });
    }
};